module.exports = __webpack_public_path__ + "media/images/favicons/mstile-310x150-2c5f2a0b22718ba43b5ca817d822f31c.png";